"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getComplaintOptions, setReportComplaint, setUpdateComplaintUserInfo } from "services/incorrect-report";
import { getContract } from "services/contracts";

import { defaultCategoryOption } from "./default-category";
import { WELCOME_SCREEN_INDEX, USER_FORM_INDEX, RESULT_SCREEN_INDEX } from "./default-category copy";

import WelcomeScreen from "./screen-1";
import UserFormScreen from "./screen-2";
import ResultScreen from "./screen-3";

import styles from "./styles.module.css";

const ModalReportIncorrect = ({ isPersonalListing }) => {
  const contractFilterVersion = 5;
  const contractExplictConsent = "explicitConsent";
  const contractKvkkName = "individualKvkk";
  const [datas, setDatas] = useState([]);
  const [complaintId, setComplaintId] = useState(null);
  const [screenName, setScreenName] = useState(WELCOME_SCREEN_INDEX);
  const [kvkkContracts, setKvkkContracts] = useState([]);

  const listingIdReduxState = useSelector((state) => state.listingDetail.listingId);

  const getDatas = async () => {
    try {
      const response = await getComplaintOptions();
      let values = [{ ...defaultCategoryOption }];
      if (response.status === "success") {
        response.result?.complaintOptions?.map((item) =>
          values.push({ key: item.issueDescKey, value: item.issueName.tr })
        );

        if (!isPersonalListing) values = values.filter((x) => x.key !== "not-from-advertised");

        setDatas(values);
      }
    } catch (error) {
      console.error(`Error for complation options! ${error}`);
    }
  };

  const handleReportComplaint = async (selectedCategory, inputValue) => {
    try {
      const response = await setReportComplaint(listingIdReduxState, {
        detailInfo: inputValue,
        issueDescKey: selectedCategory.key,
      });
      if (response.status === "success") {
        setComplaintId(response.result?.complaintId);
        setScreenName(USER_FORM_INDEX);
      }
    } catch (error) {
      console.error(`Error for report complaint form! ${error}`);
    }
  };

  const handleUserFormSend = async (userFormValues, isKvkkApproved, recaptchaRef) => {
    const recaptchaResponse = await recaptchaRef.current.execute();
    if (recaptchaResponse !== null) {
      const response = await setUpdateComplaintUserInfo(complaintId, {
        application: "desktop-web",
        contracts: kvkkContracts
          .filter((x) => x.version !== contractFilterVersion)
          .map((item) => ({
            approved: true,
            templateId: item.templateId,
            version: item.version,
            explictConsent: item.name === contractExplictConsent,
            kvkk: item.name === contractKvkkName,
          })),
        email: userFormValues.email,
        formType: "report_complaint",
        fullName: userFormValues.name,
        gRecaptchaResponse: recaptchaResponse,
        phoneNumber: userFormValues.phone,
      });
      if (response.status === "success") {
        setScreenName(RESULT_SCREEN_INDEX);
      }
    }
  };

  const getKvkkContract = async () => {
    try {
      const response = await getContract("individual_registration@modal");
      if (response.status === "success") {
        setKvkkContracts(response.result);
      }
    } catch (error) {
      console.error(`Error for kvkk contracts! ${error}`);
    }
  };

  useEffect(() => {
    getDatas();
  }, [datas.length === 0]);

  useEffect(() => {
    getKvkkContract();
  }, [kvkkContracts.length === 0]);

  return (
    <div className={styles.wrapper}>
      {screenName === 1 && (
        <WelcomeScreen
          data={datas}
          handleSend={(selectedCategory, inputValue) => handleReportComplaint(selectedCategory, inputValue)}
        />
      )}

      {screenName === 2 && (
        <UserFormScreen
          listingId={listingIdReduxState}
          handleSend={(userFormValues, isKvkkApproved, recaptchaRef) =>
            handleUserFormSend(userFormValues, isKvkkApproved, recaptchaRef)
          }
        />
      )}

      {screenName === 3 && <ResultScreen />}
    </div>
  );
};

ModalReportIncorrect.propTypes = {
  isPersonalListing: PropTypes.bool,
};

export default ModalReportIncorrect;
